import { render, staticRenderFns } from "./Chongjian.vue?vue&type=template&id=f519f3e8&scoped=true&"
import script from "./Chongjian.vue?vue&type=script&lang=js&"
export * from "./Chongjian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f519f3e8",
  null
  
)

export default component.exports